import React from "react";
import { styled } from "@mui/material/styles";
import { Paper, Table, TableBody, TableCell, TableRow, Button } from "@mui/material";

const StyledTable = styled(Table)(() => ({
  tableLayout: "fixed",
  wordWrap: "break-word",
}));

const StyledTableCell = styled(TableCell)({
  borderBottom: "none",
});

const AlternatingRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
}));

const StyledPaper = styled(Paper)(() => ({
  marginTop: "40px",
  marginBottom: "40px",
  width: "80%",
}));

export const renderArrayAsString = (vals: readonly (string | null)[] | null | undefined): string | null => {
  if (vals === null || vals === undefined) return "";
  if (vals.length === 1) {
    return vals[0];
  } else {
    const val_list = vals.reduce((x, accum) => accum + ", " + x, "");
    return val_list ? val_list.slice(0, -2) : "";
  }
};

export interface JsonListTableProps {
  data: string;
}

const JsonListTable: React.FC<JsonListTableProps> = ({ data }: JsonListTableProps) => {
  const parsedJson = JSON.parse(data);

  const allKeys: string[] = [];

  if (Array.isArray(parsedJson)) {
    parsedJson.forEach((item) => {
      Object.keys(item).forEach((key) => {
        if (!allKeys.includes(key)) {
          allKeys.push(key);
        }
      });
    });
  } else {
    Object.keys(parsedJson).forEach((key) => {
      if (!allKeys.includes(key)) {
        allKeys.push(key);
      }
    });
  }

  const formatter = new Intl.DateTimeFormat("en-NZ", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    hour12: false,
  });

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const renderCellContent = (value: any, formatter: Intl.DateTimeFormat): string | React.ReactNode => {
    if (value === undefined) return "-";
    if (typeof value === "object" && !Array.isArray(value) && value !== null) return JSON.stringify(value);
    if (typeof value === "string" && value.includes("https://nzshm22-toshi-api-prod.s3.amazonaws.com"))
      return (
        <Button variant="outlined" href={value}>
          Download
        </Button>
      );
    if (isNaN(Date.parse(value))) return value;
    return formatter.format(new Date(value));
  };

  return (
    <StyledPaper>
      <StyledTable stickyHeader size="small">
        <TableBody>
          {allKeys.map((key, index) => (
            <AlternatingRow key={index}>
              <StyledTableCell>{key}</StyledTableCell>
              <StyledTableCell>
                {renderCellContent(Array.isArray(parsedJson) ? parsedJson[0][key] : parsedJson[key], formatter)}
              </StyledTableCell>
            </AlternatingRow>
          ))}
        </TableBody>
      </StyledTable>
    </StyledPaper>
  );
};

export default JsonListTable;
